<template>
  <Disclosure v-slot="{ open }" as="nav" class="bg-grey-100 border-b border-b-gray-300 drop-shadow-lg hover:drop-shadow-xl">
    <div class="container mx-auto px-8">
      <div class="relative flex h-16 items-center justify-between">
        <div class="absolute inset-y-0 left-0 flex items-center lg:hidden">
          <!-- Mobile menu button-->
          <DisclosureButton class="relative inline-flex items-center justify-center rounded-md p-2 text-black hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-1 focus:ring-inset focus:ring-white">
            <span class="absolute -inset-0.5" />
            <span class="sr-only">Open main menu</span>
            <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
            <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
          </DisclosureButton>
        </div>
        <div class="flex flex-1 items-center justify-center lg:items-stretch lg:justify-start">
          <div class="flex flex-shrink-0 items-center">
            <router-link :to="{name:'Home'}">
              <img class="h-8 w-auto" src="../../../../img/logo.svg" alt="GroupRev Logo">
            </router-link>
          </div>
          <div class="hidden sm:ml-6 lg:block">
            <div class="flex space-x-4">
              <router-link v-for="item in items" :key="item.label" :to="item.to" :class="[item.to.name === $route.name ? 'bg-yellow-500 text-white' : 'text-black-300 hover:bg-yellow-600 hover:text-white', 'rounded-md px-3 py-2 text-sm font-medium transition-all duration-300']" :aria-current="item.current ? 'page' : undefined">
                {{ item.label }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
          <slot name="left" />
          <!-- Profile dropdown -->
          <Menu as="div" class="relative ml-3 z-1">
            <div>
              <MenuButton v-if="user" class="relative flex text-sm py-2 px-4">
                <span class="absolute -inset-1.5" />
                <span class="sr-only">Open user menu</span>
                <img v-if="user && user.avatar" class="h-8 w-8 rounded-full" :src="user.avatar.url" alt="">

                <div v-else class="relative w-8 h-8 overflow-hidden bg-gray-100 rounded-full">
                  <svg class="absolute w-8 h-8 text-gray-400 -left-1" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" /></svg>
                </div>
                <span v-if="user" class="ml-1 mt-2"> {{ user.name }} </span>
              </MenuButton>
              <menu-button v-else>
                <Bars3Icon class="h-6 w-6" aria-hidden="true" />
              </menu-button>
            </div>
            <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
              <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <MenuItem v-for="(menuItemLeft, index) in itemsLeft" v-slot="{ active }" :key="'menuItemLeft-' + index">
                  <router-link v-if="menuItemLeft.to" :to="menuItemLeft.to" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">
                    <i :class="menuItemLeft.icon" /> {{ menuItemLeft.label }}
                  </router-link>
                  <button v-else-if="menuItemLeft.command" :class="[active ? 'bg-gray-100' : '', 'block w-full text-left px-4 py-2 text-sm text-gray-700']" @click="menuItemLeft.command()">
                    <i :class="menuItemLeft.icon" /> {{ menuItemLeft.label }}
                  </button>
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>
    </div>

    <DisclosurePanel class="lg:hidden">
      <div class="space-y-1 px-2 pb-3 pt-2">
        <DisclosureButton v-for="item in items" :key="item.label" as="router-link" :to="item.to" :class="[item.current ? 'bg-gray-900 text-white' : 'text-gray-950 hover:bg-gray-700 hover:text-white', 'block rounded-md px-3 py-2 text-base font-medium cursor']" :aria-current="item.current ? 'page' : undefined">
          {{ item.label }}
        </DisclosureButton>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/vue/24/outline'

import { defineProps } from 'vue'


const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  itemsLeft: {
    type: Array,
    default: () => []
  },
  user: {
    type: Object,
    default: null
  }
})
</script>
